import _ from "lodash";
import {MARKET} from "../config";

export const getAppsPositionConfig = type => {
    let positions = {};

    switch (MARKET) {
        case 'en':
            positions = {
                eshops: [
                    'WooCommerce',
                    'Shopify',
                    'CsCart',
                    'Wix',
                    'Ecwid',
                    'Prestashop',
                    'Magento',
                    'MerchantPro',
                    'IdoSell',
                    'Shoprenter',
                    'Gomag',
                    'Unas',
                    'Shoper',
                    'SkyShop',
                    'Selly',
                ],
                accountings: [
                    'FreshBooks',
                    'Xero',
                    'Billdu',
                ],
                couriers: [
                    'Fedex',
                    'Dhl',
                    'Gls',
                    'Zasielkovna',
                    'Dpd',
                    'Foxpost',
                    'Sameday',
                    'Inpost',
                    'Boxpi',
                    'Cargus',
                ],
                marketplaces: [
                    'Amazon',
                    'Ebay',
                    'Allegro',
                    'Etsy',
                    'Emag',
                    'Kaufland',
                    'Mall',
                ],
            };
            break;

        case 'hu':
            positions = {
                eshops: [
                    'Shoprenter',
                    'Unas',
                    'WooCommerce',
                    'Shopify',
                    'CsCart',
                    'Wix',
                    'Ecwid',
                    'Prestashop',
                    'Magento',
                ],
                accountings: [
                    'Szamlazz',
                    'Billingo',
                    'Billdu',
                ],
                couriers: [
                    'Gls',
                    'Zasielkovna',
                    'Dpd',
                    'Dhl',
                    'Mpl',
                    'Fedex',
                    'Foxpost',
                    'Sameday',
                    'Boxpi',
                    'Cargus',
                ],
                marketplaces: [
                    'Emag',
                    'Allegro',
                    'Kaufland',
                    'Amazon',
                    'Ebay',
                    'Etsy',
                    'Mall',
                ],
            };
            break;

        case 'pl':
            positions = {
                eshops: [
                    'Shoper',
                    'IdoSell',
                    'SkyShop',
                    'Selly',
                    'RedCart',
                    'WooCommerce',
                    'Shopify',
                    'CsCart',
                    'Wix',
                    'Ecwid',
                    'Prestashop',
                    'Magento',
                ],
                accountings: [
                    'Fakturownia',
                    'Ifirma',
                    'Infakt',
                    'Wfirma',
                    'Billdu',
                ],
                couriers: [
                    'PocztaPolska',
                    'Inpost',
                    'Gls',
                    'Zasielkovna',
                    'Dpd',
                    'Dhl',
                    'Fedex',
                    'Geis',
                    'Boxpi',
                ],
                marketplaces: [
                    'Allegro',
                    'Emag',
                    'Kaufland',
                    'Amazon',
                    'Ebay',
                    'Etsy',
                    'Mall',
                ],
            };
            break;

        case 'ro':
            positions = {
                eshops: [
                    'Gomag',
                    'MerchantPro',
                    'WooCommerce',
                    'Shopify',
                    'CsCart',
                    'Wix',
                    'Ecwid',
                    'Prestashop',
                    'Magento',
                ],
                accountings: [
                    'SmartBill',
                    'Oblio',
                    'Billdu',
                ],
                couriers: [
                    'Gls',
                    'Zasielkovna',
                    'Dpd',
                    'Dhl',
                    'Fedex',
                    'FanCourier',
                    'Foxpost',
                    'Sameday',
                    'Boxpi',
                    'Cargus',
                ],
                marketplaces: [
                    'Emag',
                    'Allegro',
                    'Kaufland',
                    'Amazon',
                    'Ebay',
                    'Etsy',
                    'Mall',
                ],
            };
            break;
    }

    return _.has(positions, type) ? positions[type] : [];
};
